import api from "../_boot/baseApi";

export const getWebHeaderLogo = ({commit}, payload) => {
    payload.vm.loadingWebHeaderLogo = true;
    api.get(`/api/m/web/logo/header`).then(({data}) => {
        commit('setWebHeaderLogo', data.data);
        payload.vm.loadingWebHeaderLogo = false;
    })
}

export const getWebFooterLogo = ({commit}, payload) => {
    payload.vm.loadingWebFooterLogo = true;
    api.get(`/api/m/app/logo/footer`).then(({data}) => {
        commit('setWebFooterLogo', data.data);
        payload.vm.loadingWebFooterLogo = false;
    })
}

export const getAppHeaderLogo = ({commit}, payload) => {
    payload.vm.loadingAppHeaderLogo = true;
    api.get(`/api/m/app/logo/header`).then(({data}) => {
        commit('setAppHeaderLogo', data.data);
        payload.vm.loadingAppHeaderLogo = false;
    })
}

export const getAppFooterLogo = ({commit}, payload) => {
    payload.vm.loadingAppFooterLogo = true;
    api.get(`/api/m/app/logo/footer`).then(({data}) => {
        commit('setAppFooterLogo', data.data);
        payload.vm.loadingAppFooterLogo = false;
    })
}